import { Pipe, PipeTransform } from '@angular/core';
import { ImageEditorService } from '../image.editor.service';
import { Observable } from 'rxjs';
import { EventImage } from '../img.editor.iface';

@Pipe({
  name: 'getImagesByTag',
  standalone: false,
})
export class GetImagesByTagPipe implements PipeTransform {
  transform(items: EventImage[], tag: 'cover' | 'gallery' | 'seat_map' | 'unclassified' | string): EventImage[] {
    return items.filter((item) => {
      switch (tag) {
        case 'cover':
          // return ['cover', 'cover-ads', 'cover-stripe'].indexOf(item.tags[0]) >= 0
          return ['cover', 'cover-ads'].indexOf(item.tags[0]) >= 0;
        case 'cover-ads':
          return ['cover-ads'].indexOf(item.tags[0]) >= 0;
        case 'cover-main':
          return ['cover'].indexOf(item.tags[0]) >= 0;
        case 'seat_map':
          return item.tags.indexOf('seat_map') >= 0;
        case 'gallery':
          // return ['gallery-thumb', 'gallery-big'].indexOf(item.tags[0]) >= 0
          return ['gallery-big'].indexOf(item.tags[0]) >= 0;
        case 'unclassified':
          return (
            [
              'gallery-thumb',
              'gallery-big',
              'cover',
              'seat_map',
              'cover-ads',
              'cover-stripe',
            ].indexOf(item.tags[0]) < 0 || item.tags[0] === 'none'
          );
        default:
          return false;
      }
    });
  }
}

@Pipe({
  name: 'getImageDimension',
  standalone: false,
})
export class GetImageDimensionPipe implements PipeTransform {
  constructor(private IES: ImageEditorService) {}

  transform(image: string): Observable<{ base64: HTMLImageElement; x: number; y: number } | null> {
    return new Observable((observer) => {
      const fail = () => {
        // Emit null (not error) so async pipe shows Broken File without Zone "ERROR null".
        observer.next(null);
        observer.complete();
      };
      console.log('check content: ', image);
      if (!image || typeof image !== 'string') {
        fail();
        return;
      }
      if (image.indexOf('base64') >= 0) {
        let base64Image = new Image();
        base64Image.src = image as string;
        base64Image.onload = () => {
          const dim = {
            base64: base64Image,
            x: base64Image.width,
            y: base64Image.height,
          };
          base64Image = null;
          observer.next(dim);
          observer.complete();
        };
        base64Image.onerror = () => {
          base64Image = null;
          fail();
        };
      } else {
        // Handle as file
        let file = new FileReader();
        console.log('reader::: ', image, file);
        this.IES.getImageAsBase64(image).subscribe({
          next: (res) => {
            let img = new Image();
            img.src = res;
            img.onload = () => {
              const dim = {
                base64: img,
                x: img.width,
                y: img.height,
              };
              img = null;
              file = null;
              observer.next(dim);
              observer.complete();
            };
            img.onerror = () => {
              img = null;
              file = null;
              fail();
            };
          },
          error: () => {
            file = null;
            fail();
          },
        });
      }
    });
  }
}
